import { get } from '@/utils/fetch';
import type { FetchResponse } from '@/utils/fetch';
import { isMobile } from '@/utils';
import { getCodeVerifier } from '@/utils/pkce';
import { getAuthURLByPlatform } from '@/utils/platform';

interface Signature {
  appId: string;
  signature: string;
  timestamp: number;
  nonce: string;
}

/**
 * 獲取簽名數據
 * @param url
 * @returns
 */
export async function signature(url: string): Promise<Signature> {
  const res: FetchResponse<Signature> = await get('/token/signature', {
    url,
  });
  return res.data;
}

/**
 * 獲取用戶登錄信息
 * @returns
 */
export async function getLoginUserInfo() {
  const res: FetchResponse<{ any }> = await get('/token/login');
  return res;
}

type SSOGrantParamsType = {
  code: string;
  redirectUri: string;
  accountType: string;
};

/**
 * 根據codeflow後拿到的code請求後端獲取jwt token
 * @param params
 * @returns
 */
export const getTokenByCode = (params: SSOGrantParamsType) => {
  const codeVerifier = getCodeVerifier();
  return get(
    '/token/oauth2',
    {
      ...(codeVerifier ? { codeVerifier } : {}),
      ...params,
    },
    { canSendWithoutToken: true },
  );
};

/**
 * 1. 請求後端接口獲取 YiWangToken；
 * 2. 調用 syncYiWangToken 傳遞給 iframe Header
 */
export const exchangeYiWangToken = async () => {
  if (isMobile()) {
    return true;
  }
  const res: FetchResponse<string> = await get('/token/accout/pc', {
    clientType: 'WEB',
  });
  if (!res?.data) return false;

  const iframe = document.getElementById('iframeHeader') as HTMLIFrameElement;
  const sendMessage = () => {
    iframe?.contentWindow?.postMessage?.(
      {
        type: 'headerFrameOriginChangeToken',
        token: res?.data,
      },
      getAuthURLByPlatform(),
    );
  };
  // 處理iframe已預先加載好的問題
  sendMessage();
  // 保证iframe加载后再发消息。
  iframe?.addEventListener?.('load', sendMessage);
};
